import React from 'react';
import { Text } from '@mantine/core';
import { FONT_WEIGHTS } from '../../theme/theme';

interface CountBadgeProps {
  count: number;
  size?: 'default' | 'large';
}

export function CountBadge({ count, size = 'default' }: CountBadgeProps) {
  const isLarge = size === 'large';

  return (
    <Text
      component="span"
      size={isLarge ? 'textSm' : 'textXs'}
      fw={FONT_WEIGHTS.medium}
      bg="gray.1"
      c="gray.8"
      px={isLarge ? 'xs' : 'xxs'}
      py={isLarge ? 'xxxs' : undefined}
      style={{
        display: 'inline-block',
        borderRadius: 999,
        border: '1px solid var(--mantine-color-gray-3)',
      }}
    >
      {count}
    </Text>
  );
}
